import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortenUrl',
    standalone: false
})
export class ShortenUrlPipe implements PipeTransform {
  transform(
    url: string,
    maxStartLength: number = 15,
    maxTotalLength: number = 40,
    maxEndLength: number = 25,
  ): string {
    if (!url) return '';

    try {
      // If the URL is already within the max length, return it as is
      if (url.length <= maxTotalLength) return url;

      const lastSlashIndex = url.lastIndexOf('/');
      let endPart = url.substring(lastSlashIndex + 1);

      // If the last part is still too long, just take the last maxEndLength characters
      if (endPart.length > maxEndLength) {
        endPart = endPart.slice(-maxEndLength); // Take last 10 chars of the URL
      }

      // Adjust the start part to fit within the total allowed length
      const remainingLength = maxTotalLength - 3 - endPart.length; // Account for "..."
      let startPart = url.substring(
        0,
        Math.min(maxStartLength, remainingLength),
      );

      return `${startPart}...${endPart}`;
    } catch (e) {
      return url; // Return original URL if there's an issue
    }
  }
}
